// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ffumn","delete":"styles_delete__3OWgL","update":"styles_update__3XWQi","add":"styles_add__2dmM0"};